import React, { useState, useEffect } from 'react';
import '../CSS/temperature.css';
import { fetchLastPoint } from '../FireBase/firebaseService';

function Thermometre() {
  const [lastPoint, setLastPoint] = useState(null);
  const [position, setPosition] = useState({ x: '48%', y: '70%' });
  const [isDragging, setIsDragging] = useState(false);
  const collectionName = localStorage.getItem('collectionName') || '/data';

  useEffect(() => {
    const unsubscribe = fetchLastPoint(
      collectionName,
      (point) => setLastPoint(point),
      (error) => console.error(error)
    );
    return () => unsubscribe();
  }, [collectionName]);

  const handleMouseDown = () => setIsDragging(true);
  const handleMouseMove = (e) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - 30,
        y: e.clientY - 100,
      });
    }
  };
  const handleMouseUp = () => setIsDragging(false);

  const getLiquidHeight = () => {
    const temperature = lastPoint?.Deg ?? 0;
    const validTemperature = Math.max(-30, Math.min(temperature, 50));
    return ((validTemperature + 30) / 80) * 100;
  };

  const getLiquidColor = () => {
    const temperature = lastPoint?.Deg ?? 0;
    const validTemperature = Math.max(-30, Math.min(temperature, 50));

    if (validTemperature <= 0) return ['#007BFF', '#e8f3ff'];
    if (validTemperature > 0 && validTemperature <= 25) return ['#FFA500', '#ffedcc'];
    return ['#FF0000', '#ffa6a6'];
  };

  return (
    <div
      className="thermometre-container"
      style={{ left: position.x, top: position.y, position: 'absolute' }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseUp}
    >
      <div
        className="thermometre-box"
        onMouseDown={handleMouseDown}
        style={{ cursor: 'grab', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
      >
        {lastPoint ? (
          <div
            style={{
              position: 'relative',
              width: '70px',
              height: '220px',
              background: 'linear-gradient(145deg, #f0f0f0, #d9d9d9)',
              borderRadius: '35px',
              boxShadow: 'inset 4px 4px 10px rgba(0, 0, 0, 0.2), inset -4px -4px 10px rgba(255, 255, 255, 0.7)',
              overflow: 'hidden',
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                position: 'absolute',
                bottom: '0',
                width: '100%',
                height: `${getLiquidHeight()}%`,
                background: `linear-gradient(to top, ${getLiquidColor()[0]},${getLiquidColor()[1]})`,
                borderRadius: '35px 35px 0 0',
                transition: 'height 0.5s ease, background 0.5s ease',
              }}
            ></div>
            <div className="graduations">
              {[-10, 0, 10, 20, 30, 40].map((grad) => (
                <div
                  key={grad}
                  style={{
                    position: 'absolute',
                    width: '100%',
                    textAlign: 'center',
                    top: `${((78 - (grad + 30)) / 80) * 100}%`,
                    fontSize: '10px',
                    color: 'black',
                  }}
                >
                  <span style={{ position: 'relative', left: '-52px'}}>{grad}°C</span>
                  <hr style={{ width: '80%', border: '0.5px solid #ccc', margin: '2px auto' }} />
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p>Chargement...</p>
        )}

        {lastPoint && (
          <p className="temperature" style={{ fontSize: '20px', fontWeight: 'bold', marginTop: '10px' }}>
            {lastPoint.Deg}°C
          </p>
        )}
      </div>
    </div>
  );
}

export default Thermometre;
